import script from "./MyUtilityModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyUtilityModal.vue?vue&type=script&setup=true&lang=ts"

import "./MyUtilityModal.vue?vue&type=style&index=0&id=1065a8af&lang=css"

const __exports__ = script;

export default __exports__